import { ISerialisedDocumentReference } from '@principle-theorem/shared';
import { IAppointmentDimension } from '../dimensions/appointment';
import { IInvoiceDimension } from '../dimensions/invoice';
import { ITimestampedFact, ITreatmentPlanScopedFact } from './common';

export interface ITreatmentPlanCompletedFact
  extends ITreatmentPlanScopedFact,
    ITimestampedFact {
  invoiceRefs: ISerialisedDocumentReference[];
  appointmentRefs: ISerialisedDocumentReference[];
  invoices: IInvoiceDimension[];
  appointments: IAppointmentDimension[];
  finalCost: number; // TODO: Requires treatment cost value
  initialCost: number;
  planChanges: number; // TODO: Requires tracking of changes to treatments in treatment steps
  totalDuration: number;
}
